import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const menusStore = {
    actionCreators,
    reducer,
};

export default menusStore;
